import { useFormContext } from "react-hook-form";
import { ProfileFormData } from "../pages/EditProfile";
import UserMedal from "../interfaces/userMedal";
import { ASSETS_URL } from "../util/constants";

const EditMedals = ({ data }: { data: UserMedal[] }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<ProfileFormData>();

  if (!data || data.length === 0)
    return (
      <div className="alert alert-info text-center">
        No medals found to edit.
      </div>
    );

  const findMedalIndex = (medalId: number) => {
    return data.findIndex((m) => m.medal.id === medalId);
  };

  return (
    <>
      <h3 className="mb-3" style={{ color: "#ff8200" }}>
        Medals
      </h3>
      <hr style={{ borderColor: "#ff8200", marginBottom: "1.5rem" }} />
      <div
        className="mb-4 d-flex flex-wrap justify-content-around align-items-end"
        style={{ gap: "1.5rem" }}
      >
        {data
          .filter((medal) => medal.medal.medalType.slug === "pokedex" || medal.medal.medalType.slug === "medals")
          .map((medal) => {
            const index = findMedalIndex(medal.medal.id!);
            if (index === -1) return null;

            let pathImage = `${ASSETS_URL}/${medal.medal.pathImage}`;
            if (medal.quantity >= medal.medal.amountForPlatinum)
              pathImage += "_Platinum.png";
            else if (medal.quantity >= medal.medal.amountForGold)
              pathImage += "_Gold.png";
            else if (medal.quantity >= medal.medal.amountForSilver)
              pathImage += "_Silver.png";
            else if (medal.quantity >= medal.medal.amountForBronze)
              pathImage += "_Bronze.png";
            else pathImage += "_Shadow.png";

            return (
              <div key={medal.medal.id} className="text-center">
                <div>
                  {medal.medal.name}
                </div>
                <img
                  src={pathImage}
                  alt={medal.medal.name}
                  style={{
                    width: "4rem",
                    height: "4rem",
                    objectFit: "contain",
                  }}
                  className="mb-2"
                />
                <input
                  type="number"
                  {...register(`medals.${index}.quantity`, {
                    valueAsNumber: true,
                  })}
                  onWheel={(e) => (e.target as HTMLElement).blur()}
                  className={`form-control form-control-sm ${
                    errors.medals?.[index]?.quantity ? "is-invalid" : ""
                  }`}
                />

                <input
                  type="hidden"
                  {...register(`medals.${index}.medal.id`, {
                    valueAsNumber: true,
                  })}
                />

                {errors.medals?.[index]?.quantity && (
                  <p
                    className="text-danger mt-1 mb-0"
                    style={{ fontSize: "0.75rem" }}
                  >
                    {errors.medals[index]?.quantity?.message}
                  </p>
                )}
              </div>
            );
          })}
      </div>

      <h3 className="mb-3" style={{ color: "#ff8200" }}>
        Type Captures
      </h3>
      <hr style={{ borderColor: "#ff8200", marginBottom: "1.5rem" }} />
      <div
        className="mb-4 d-flex flex-wrap justify-content-around align-items-end"
        style={{ gap: "1.5rem" }}
      >
        {data
          .filter((medal) => medal.medal.medalType.slug === "type-captures")
          .map((medal) => {
            const index = findMedalIndex(medal.medal.id!);
            if (index === -1) return null;

            let pathImage = `${ASSETS_URL}/${medal.medal.pathImage}`;
            if (medal.quantity >= medal.medal.amountForPlatinum)
              pathImage += "_Platinum.png";
            else if (medal.quantity >= medal.medal.amountForGold)
              pathImage += "_Gold.png";
            else if (medal.quantity >= medal.medal.amountForSilver)
              pathImage += "_Silver.png";
            else if (medal.quantity >= medal.medal.amountForBronze)
              pathImage += "_Bronze.png";
            else pathImage += "_Shadow.png";

            return (
              <div key={medal.medal.id} className="text-center">
                <div>
                  {medal.medal.name}
                </div>
                <img
                  src={pathImage}
                  alt={medal.medal.name}
                  style={{
                    width: "4rem",
                    height: "4rem",
                    objectFit: "contain",
                  }}
                  className="mb-2"
                />
                <input
                  type="number"
                  {...register(`medals.${index}.quantity`, {
                    valueAsNumber: true,
                  })}
                  onWheel={(e) => (e.target as HTMLElement).blur()}
                  className={`form-control form-control-sm ${
                    errors.medals?.[index]?.quantity ? "is-invalid" : ""
                  }`}
                />
                <input
                  type="hidden"
                  {...register(`medals.${index}.medal.id`, {
                    valueAsNumber: true,
                  })}
                />

                {errors.medals?.[index]?.quantity && (
                  <p
                    className="text-danger mt-1 mb-0"
                    style={{ fontSize: "0.75rem" }}
                  >
                    {errors.medals[index]?.quantity?.message}
                  </p>
                )}
              </div>
            );
          })}
      </div>
    </>
  );
};

export default EditMedals;
